import { render } from "./RenewalDocuments.vue?vue&type=template&id=570af0cc"
import script from "./RenewalDocuments.vue?vue&type=script&lang=js"
export * from "./RenewalDocuments.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__